var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPromise1 = function SvgPromise1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 62,
    viewBox: "0 0 61 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.48,
    height: 24.57,
    x: 32.64,
    y: 0.514,
    stroke: "#0c74c6",
    strokeWidth: 2.5,
    rx: 12.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.48,
    height: 24.57,
    x: 32.64,
    y: 32.455,
    stroke: "#0c74c6",
    strokeWidth: 2.5,
    rx: 12.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.48,
    height: 24.57,
    y: 32.455,
    stroke: "#0c74c6",
    strokeWidth: 2.5,
    rx: 12.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.48,
    height: 24.57,
    y: 0.514,
    stroke: "#0c74c6",
    strokeWidth: 2.5,
    rx: 12.24
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 8.19,
    d: "M13.147 11.375L24.48.514"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c74c6",
    strokeWidth: 2.5,
    d: "M7.44 12.083l4.924 5.297L28.294 1"
  }))));
};
export default SvgPromise1;